export default __webpack_public_path__ + "static/media/P200-sm-close.f11de7e3.svg";